import { HttpError } from './HttpError';

/** GET a JSON document. Throws HttpError on non-2xx, AbortError when the signal fires. */
export async function fetchJson<T>(url: string, signal?: AbortSignal): Promise<T> {
  const res = await fetch(url, { signal });
  if (!res.ok) throw new HttpError(res.status, url);
  return (await res.json()) as T;
}
